import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { BitmapText } from "appworks/graphics/pixi/bitmap-text";
import { AbstractControl } from "../../abstract-control";

export abstract class AbstractTextControl extends AbstractControl {
    constructor(protected text: FlexiText | BitmapText) {
        super();
    }
}
